import React, { createContext, useContext, useState, useCallback } from 'react';
import { cartAPI } from '../api';
import { useAuth } from './AuthContext';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(false);

  const fetchCart = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await cartAPI.getCart();
      setCart(data);
    } catch {
      setCart({ items: [], total: 0 });
    } finally {
      setLoading(false);
    }
  }, [user]);

  const addToCart = async (productId, quantity = 1) => {
    await cartAPI.addToCart({ product_id: productId, quantity });
    await fetchCart();
  };

  const updateItem = async (productId, quantity) => {
    await cartAPI.updateItem({ product_id: productId, quantity });
    await fetchCart();
  };

  const removeItem = async (productId) => {
    await cartAPI.removeItem(productId);
    await fetchCart();
  };

  const clearCart = async () => {
    await cartAPI.clearCart();
    setCart({ items: [], total: 0 });
  };

  return (
    <CartContext.Provider value={{ cart, loading, fetchCart, addToCart, updateItem, removeItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
